import { styled, Box, Grid, Typography, Stack } from "@mui/material";
import { LoginIllustration, ErrorCircleIcon } from "react-common-ui-library";

export const StyledCreateAccountLinkBox = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
}));

export const StyledLoginIllustration = styled(LoginIllustration)(
  ({ theme }) => ({
    height: "464.91px",
    width: "485px",
    fill: "#D0F3FF31",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  })
);

export const StyledLoginIllustrationStack = styled(Stack)(() => ({
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  margin: "153px 106px",
}));

export const StyledLoginFormGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.background.paper,
}));

export const StyledLoginImageGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
}));

export const StyledLoginFormBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  margin: theme.spacing(8, 9),
  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(2.5),
  },
}));

export const StyledLoginFormStack = styled(Stack)(({ theme }) => ({
  width: "520px",
  margin: "80px 10px",
  [theme.breakpoints.down("sm")]: {
    margin: 0,
    width: "100%",
  },
}));

export const StyledLoginErrorTypography = styled(Typography)(({ theme }) => ({
  fontStyle: "italic",
  color: theme.palette.error.main,
}));

export const StyledErrorCircleIcon = styled(ErrorCircleIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: "inherit",
}));

export const StyledErrorMessageStack = styled(Stack)(() => ({
  flexDirection: "row",
}));
